import { StdResponse, request } from "@/global/config/request";

export function getServerDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/servers/${id}`, {
        params: {
            ...params,
        }
    })
}